/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-01-02 12:16:01                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-02 12:17:13                               *
 *****************************************************************************/

/* SUMMARY
  * Components
  * Styles
*/

/* Imports */
import { useState } from "react";
/***/

/* Components */
import { LeftNavigationBar } from "./left-navigation-bar/LeftNavigationBar";
import { TopNavigationBar } from "./top-navigation-bar/TopNavigationBar";
/***/

/* Styles */
import "./NavigationLayout.scss";
/***/

/**
* NavigationLayout: connected layout
* Contain all default navigation for the web app 
* @param children - elements to print inside
*/
export default function NavigationLayout({children}: any) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="navigation-layout">
      <LeftNavigationBar 
        className="left-navbar"
        isOpen={isMobileMenuOpen}
        onClose={closeMobileMenu}
      />
      <TopNavigationBar 
        className="top-navbar" 
        onMenuToggle={toggleMobileMenu}
      />
      
      <div className="app-content">
        {children}
      </div>
    </div>
  );
}
/***/
